module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_8003.c694c73d.png";